export enum Size {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
